import '@babel/polyfill';
import cssVars from 'css-vars-ponyfill';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';
import store from '@/store';
import vuetify from './plugins/vuetify';
import VueCookie from 'vue-cookie';
import Meta from 'vue-meta';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import recaptchaKeys from '@/config/recaptcha-key';

cssVars({
    // Options...
});

Vue.use(Vuelidate);
Vue.use(Meta);
Vue.use(VueCookie);
Vue.use(VueReCaptcha, {
    siteKey: recaptchaKeys.v3,
    loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true,
    },
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
